export default __webpack_public_path__ + "8c07e7c7844e5fa42fa62770083a2fc6.svg";